// carData.js

const carData = [
  {
    id: 21,
    name: "Mazda Cx-5",
    day: "6,500",
    week: "40,000",
    seating: "5 Seater",
    image: "https://res.cloudinary.com/dv4c3pcug/image/upload/v1770981433/WhatsApp_Image_2026-02-13_at_02.49.53_cqvx2d.jpg",
  },
  {
    id: 2,
    name: "Toyota Vanguard 2012 model Pearl White",
    day: "7,000",
    week: "48,000",
    seating: "7 Seater",
    image: "./assets/images/car-1.png",
  },
  {
    id: 3,
    name: "Nissan X-trail 4x4 2.0 Ltr",
    day: "5,000",
    week: "30,000",
    seating: "7 Seater",
    image: "./assets/images/car-2.png",
  },
  {
    id: 1,
    name: "Toyota Prado TX 4x4 J150 Black",
    day: "15,000",
    week: "90,000",
    seating: "7 Seater",
    image: "./assets/images/car-3.png",
  },
  {
    id: 3,
    name: "Toyota Fielder",
    day: "4,000",
    week: "20,000",
    seating: "5 Seater",
    image: "https://res.cloudinary.com/dwagdb70s/image/upload/v1775585241/WhatsApp_Image_2026-04-07_at_19.30.00_qb94jw.jpg",
  },
];

export default carData;
